<app-top-bar [title]="page.title"></app-top-bar>
<div class="static-page py-3">
    <div class="container-fluid">
        <div [innerHTML]="page.content"></div>
    </div>
</div>
